import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'aaos-app-fail-modal',
  templateUrl: './fail-modal.component.html',
  styleUrls: ['./fail-modal.component.scss']
})
export class FailModalComponent implements OnInit {

  failedResModels;
  errors;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.failedResModels = this.data.failedResModels;
    this.errors = this.data.errors;
    let interval = 2000;
    if (this.data && this.data.autoCloseInterval) {
      interval = this.data.autoCloseInterval;
    }
    setInterval(() => {
    }, interval);
  }
}
